<template>
    <p-card :title="title" class="mt-2">
        <div class="mb-2 d-flex align-items-center gap-2">
            <b-dropdown text="Export" variant="outline-primary" size="sm">
                <b-dropdown-item
                    v-for="f in exportFormats"
                    :key="f.id"
                    @click="$emit('export', f.id)">{{ f.label }}</b-dropdown-item>
            </b-dropdown>
            <span class="small text-muted">Exports every matching row, not just this page.</span>
        </div>
        <p v-if="!rows.length" class="mb-2">Nothing matched. Try different settings.</p>
        <template v-else>
            <p-table
                :items="rows"
                :fields="fields"
                :pagination="false"
                :per-page="0"
                :enable-row-selection="false"
                :show-record-count="false"
                :is-busy="busy"
                no-local-sorting
                @sort-by-change="sortBy = $event"
                @sort-desc-change="$emit('sort', { sortBy, sortDesc: $event })" />
            <ServerPager
                :total="total"
                :page="page"
                :per-page="perPage"
                @page="$emit('page', $event)"
                @per-page="$emit('per-page', $event)" />
        </template>
    </p-card>
</template>

<script>
// One page of a server report's rows: sorted and paged by the server, exported by the
// server. Shared by the report generator and a saved report's own page.
import ServerPager from '@/views/Reports/Agent/ServerPager.vue';

const MONEY = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

// Dates arrive as UTC and show in the browser's (the store's) time; money as dollars.
function formatCell(format, value) {
    if (value === null || value === undefined || value === '')
        return '';

    if (format === 'date')
        return new Date(value).toLocaleString('en-US', { dateStyle: 'short', timeStyle: 'short' });

    if (format === 'money')
        return MONEY.format(Number(value));

    return value;
}

export default {
    name: 'ServerReportResults',
    components: { ServerPager },
    props: {
        title: { type: String, required: true },
        rows: { type: Array, default: () => [] },
        columns: { type: Array, default: () => [] },
        total: { type: Number, default: 0 },
        page: { type: Number, default: 1 },
        perPage: { type: Number, default: 25 },
        busy: { type: Boolean, default: false },
    },
    emits: ['page', 'per-page', 'sort', 'export'],
    data() {
        return {
            sortBy: null,
            exportFormats: [{ id: 'csv', label: 'CSV' }, { id: 'pdf', label: 'PDF' }],
        };
    },
    computed: {
        // The server says which columns it can sort in SQL; the rest offer no sort.
        fields() {
            return this.columns.map(column => ({
                key: column.key,
                label: column.label,
                sortable: column.sortable !== false,
                formatter: value => formatCell(column.format, value),
            }));
        },
    },
};
</script>
